import { render } from "./Groupes.vue?vue&type=template&id=0ea02920"
import script from "./Groupes.vue?vue&type=script&lang=js"
export * from "./Groupes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__